import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'


const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState('all');
  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          I have worked on a wide range of projects. Here are some of my projects.
        </Desc>
        <ToggleButtonGroup >
          {toggle === 'all' ?
            <ToggleButton active value="all" onClick={() => setToggle('all')}>All</ToggleButton>
            :
            <ToggleButton value="all" onClick={() => setToggle('all')}>All</ToggleButton>
          }
          <Divider />
          {toggle === 'Data Science(ML-DL)' ?
            <ToggleButton active value="Data Science(ML-DL)" onClick={() => setToggle('Data Science(ML-DL)')}>Data Science(ML-DL)</ToggleButton>
            :
            <ToggleButton value="Data Science(ML-DL)" onClick={() => setToggle('Data Science(ML-DL)')}>Data Science(ML-DL)</ToggleButton>
          }
          <Divider />

          {toggle === 'Java' ?
            <ToggleButton active value="Java" onClick={() => setToggle('Java')}>Java</ToggleButton>
            :
            <ToggleButton value="Java" onClick={() => setToggle('Java')}>Java</ToggleButton>
          }
          <Divider />

          {toggle === 'PYTHON' ?
            <ToggleButton active value="Python" onClick={() => setToggle('Python')}>Python</ToggleButton>
            :
            <ToggleButton value="Python" onClick={() => setToggle('Python')}>Python</ToggleButton>
          }
          <Divider />

          {toggle === 'Robotic Process Automation' ?
            <ToggleButton active value="Robotic Process Automation" onClick={() => setToggle('Robotic Process Automation')}>Robotic Process Automation</ToggleButton>
            :
            <ToggleButton value="Robotic Process Automation" onClick={() => setToggle('Robotic Process Automation')}>Robotic Process Automation</ToggleButton>
          }
          <Divider />
          
          {toggle === 'Software Testing(Selenium)' ?
            <ToggleButton active value="Software Testing(Selenium)" onClick={() => setToggle('Software Testing(Selenium)')}>Software Testing(Selenium)</ToggleButton>
            :
            <ToggleButton value="Software Testing(Selenium)" onClick={() => setToggle('Software Testing(Selenium)')}>Software Testing(Selenium)</ToggleButton>
          }

        </ToggleButtonGroup>
        <CardContainer>
          {toggle === 'all' && projects
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal} />
            ))}
          {projects
            .filter((item) => item.category === toggle)
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal} />
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects